import { useRouteContext } from 'src/hooks/useRouteContext';

export const useDictionary = () => {
  const defaultDictionary = {
    playVideoLabel: 'Play Video',
    viewTranscriptLabel: 'Transcript',
    deleteLabel: 'Delete',
    jumpLinksDropdownLabel: 'Jump to section',
    officeLabel: 'Office',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    businessPhoneLabel: 'Business',
    mobilePhoneLabel: 'Mobile',
    faxLabel: 'Fax',
    downloadLabel: 'Download',
    educationAdmissionsLabel: 'Education, Bar Admissions & Court Admissions',
    educationLabel: 'Education',
    barAdmissionsLabel: 'Bar Admissions',
    courtAdmissionsLabel: 'Court Admissions',
    languagesLabel: 'Languages',
    awardsLabel: 'Awards & Recognitions',
    involvementLabel: 'Professional & Community Involvement',
    professionalInvolvementLabel: 'Professional Involvement',
    communityInvolvementLabel: 'Community Involvement',
    acknowledgementsLabel: 'Acknowledgements',
    shareLabel: 'Share',
    readMoreLabel: 'Read More',
    readLessLabel: 'Read Less',
    showAllLabel: 'Show All',
    dateLabel: 'Date',
    timeLabel: 'Time',
    locationLabel: 'Location',
    registerLabel: 'Register',
    addToCalendarLabel: 'Add Event to Calendar',
    contactInformationLabel: 'Contact Information',
    addressLabel: 'Address',
    getDirectionsLabel: 'Get Directions',
    directionDetailsLabel: 'Directions',
    officeContactLabel: 'Office Contact',
    selectAllLabel: 'Select All',
    requiredFieldsLabel: '* Required fields',
    expandAllLabel: 'Expand All +',
    collapseAllLabel: 'Collapse All -',
    filtersLabel: 'Filters',
    recentSearchesLabel: 'Recent Searches',
    resultsCountTemplate: 'Showing {count} of {total} Results',
    queryFilterLabel: 'Search Term',
    serviceFilterLabel: 'Service(s)',
    locationFilterLabel: 'Location(s)',
    letterFilterLabel: 'Letter',
    clearAllLabel: 'Clear all',
    menuLabel: 'Menu',
    filterServicesLabel: 'Filter Services',
    searchResultsReturnedLabel: 'Search results returned',
    sortByLabel: 'Sort by',
    loadMoreLabel: 'Load More',
    seeMoreLabel: 'See more',
    allResultsLabel: 'All results',
    relevanceLabel: 'Relevance',
  };

  const dictionary = { ...defaultDictionary };

  // Populate dictionary with overrides from Website Settings

  const { routeData } = useRouteContext();

  Object.entries(dictionary).forEach(([key, defaultValue]) => {
    const overriddenValue = routeData?.dictionary?.[defaultValue];

    if (overriddenValue !== undefined) {
      dictionary[key as keyof typeof dictionary] = overriddenValue;
    }
  });

  return {
    ...dictionary,
    t: (lookup: string) => {
      const key = Object.entries(defaultDictionary).find(
        ([_, defaultValue]) => defaultValue === lookup
      )?.[0];
      return dictionary[key as keyof typeof dictionary] || lookup;
    },
    computeResultsCountLabel: (count: number | string, total: number | string) => {
      const template = dictionary.resultsCountTemplate;
      return template.replace('{count}', count.toString()).replace('{total}', total.toString());
    },
  };
};
